var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTranslateBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1437_8956",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1437_8956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.91661 17.9165L13.6281 8.33318H14.9293L18.641 17.9165H17.3156L16.3718 15.3748H12.1858L11.2418 17.9165H9.91661ZM3.3412 15.4646L2.46307 14.5863L6.60724 10.4342C6.12654 9.94811 5.6696 9.37117 5.23641 8.70339C4.80307 8.03561 4.44648 7.35666 4.16661 6.66652H5.49182C5.73224 7.17082 6.02474 7.67513 6.36932 8.17943C6.71391 8.6836 7.08599 9.14242 7.48557 9.55589C8.07738 8.95867 8.63717 8.23353 9.16495 7.38048C9.69273 6.52742 10.0656 5.73388 10.2837 4.99985H1.41016V3.74985H6.87495V2.40381H8.12495V3.74985H13.5897V4.99985H11.5495C11.2793 5.93568 10.8485 6.91402 10.2572 7.93485C9.66585 8.95568 9.03467 9.79735 8.3637 10.4598L10.4197 12.5655L9.94703 13.8492L7.48557 11.3251L3.3412 15.4646ZM12.5864 14.269H15.971L14.2787 9.72256L12.5864 14.269Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslateBlackIcon);
export default __webpack_public_path__ + "static/media/translate-black-icon.2de1c78a4457ddc54911da3a85be82ec.svg";
export { ForwardRef as ReactComponent };